export default __webpack_public_path__ + "static/media/grey-car-pollution-smoke.1bf89d7c.png";